import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Paper from '@material-ui/core/Paper'
import Divider from '@material-ui/core/Divider'
import Box from '@material-ui/core/Box'
import Link from '@material-ui/core/Link'
import SettingsIcon from '@material-ui/icons/Settings'
import AdapterLink from 'utils/AdapterLink'
import GradientFab from 'components/common/GradientFab'
import MessageForm from 'components/home/MessageForm'
import SendClapButton from 'components/home/SendClapButton'
import useGlobal from 'hooks/useGlobal'

const useStyles = makeStyles(theme => ({
	content: {
		[theme.breakpoints.up('md')]: {
			display: 'flex',
			marginTop: theme.spacing(6),
			marginBottom: theme.spacing(6),
			marginLeft: theme.spacing(3),
			padding: theme.spacing(4),
		},
		[theme.breakpoints.down('sm')]: {
			marginTop: theme.spacing(2),
			marginBottom: theme.spacing(2),
		},
	},
	imageBox: {
		backgroundColor: theme.palette.grey[100],
		backgroundImage: props => `url(${process.env.PUBLIC_URL}/${props.img})`,
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'center center',
		[theme.breakpoints.up('md')]: {
			width: 300,
			marginLeft: theme.spacing(-9),
		},
		[theme.breakpoints.down('sm')]: {
			width: '100%',
			height: 200,
			backgroundPosition: 'center 40%',
			boxShadow: 'none',
			borderBottom: `1px solid ${theme.palette.divider}`,
		},
	},
	formBox: {
		position: 'relative',
		flexBasis: 0,
		flexGrow: 1,
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1),
		paddingRight: theme.spacing(3),
		paddingLeft: theme.spacing(4),
		[theme.breakpoints.down('sm')]: {
			padding: theme.spacing(3),
		},
	},
	fab: {
		position: 'absolute',
		bottom: theme.spacing(-7.5),
		[theme.breakpoints.down('sm')]: {
			bottom: theme.spacing(-3),
			right: theme.spacing(1),
		},
	},
}))

function Home() {
	const [config] = useGlobal(state => state.config)
	const classes = useStyles({ img: config.wc_main_img })

	useEffect(() => {
		document.title = config.wc_title
	}, [config.wc_title])

	return (
		<Container maxWidth="md">
			<Paper square className={classes.content}>
				<Paper square className={classes.imageBox} />
				<Box className={classes.formBox}>
					<Box mb={4}>
						<Box color="grey.500" fontSize="caption.subtitle1" fontWeight="fontWeightLight">
							<Link
								href="https://solution-release.tistory.com"
								target="_blank"
								color="inherit"
								underline="none"
							>
								WebClap &copy; SR
							</Link>
						</Box>
						<Box fontSize="h5.fontSize" fontWeight="fontWeightMedium">
							{config.wc_main_msg}
						</Box>
					</Box>
					<Box textAlign="center" mb={2}>
						<SendClapButton />
					</Box>
					<Divider />
					<Box>
						<MessageForm />
					</Box>
					<GradientFab
						component={AdapterLink}
						to="/admin"
						color="primary"
						size="medium"
						aria-label="admin"
						className={classes.fab}
					>
						<SettingsIcon />
					</GradientFab>
				</Box>
			</Paper>
		</Container>
	)
}

export default Home
